import { EditPriceDialogComponent } from "./../edit-price-dialog/edit-price-dialog.component";
import { MatSort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { Price } from "./../_models/price";
import { PriceService } from "./../_services/price.service";
import { ZoneService } from "./../_services/zone.service";
import { CourierService } from "./../_services/courier.service";
import { Location } from "@angular/common";
import { Component, OnInit, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { switchMap } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { Globals } from "../globals";
import { ProductContent } from "../_models/product-content";
import { ProductPrice } from "../_models/product-price";
import _ from "lodash";
import { Courier } from "../_models/courier";
import { Zone } from "../_models/zone";

@Component({
  selector: "app-view-zone-page",
  templateUrl: "./view-zone-page.component.html",
  styleUrls: ["./view-zone-page.component.scss"],
})
export class ViewZonePageComponent implements OnInit {
  public categories = new FormControl();
  public isDataLoaded = false;
  public isModified = false;
  public newProductContent = new ProductContent();
  public zone: Zone;
  public couriers: Courier[];
  public prices: Price[];
  public showAddContents = false;
  public selectedCountry: number = 0;

  public displayedColumns = ["Id", "Weight", "Amount", "Active", "Buttons"];
  public dataSource: MatTableDataSource<Price>;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private activatedRoute: ActivatedRoute,
    public courierService: CourierService,
    public zoneService: ZoneService,
    public priceService: PriceService,
    public globals: Globals,
    private location: Location,
    public snackBar: MatSnackBar,
    public uploadDialog: MatDialog,
    public priceDialog: MatDialog,
    private router: Router
  ) { }

  public activate(): void {
    this.zone.active = true;
    this.save();
  }

  public back(): void {
    this.location.back();
  }

  public cancel(): void {
    this.refresh();
  }

  public dataChanged(): void {
    this.isModified = true;
  }

  public deactivate(): void {
    this.zone.active = false;
    this.save();
  }

  public addPrice() {
    const priceDialogRef = this.priceDialog.open(EditPriceDialogComponent, {
      data: {
        addPrice: true,
        zoneId: this.zone.id,
      },
    });

    priceDialogRef.afterClosed().subscribe((result) => {
      console.log("Price Dialog: ", result);
      this.refresh();
    });
  }

  public delete() {
    this.zoneService.deleteZone(this.zone.id).subscribe(
      (res) => {
        this.router.navigate(["regional", "zones"]);
      },
      (err) => {
        console.error(err);
        this.showErrorMessage(
          "Sorry, your request cannot be process at the moment!"
        );
      }
    );
  }

  public getImageUrl(): string {
    return environment.imageUrl;
  }

  public loadData(zoneId: number) {
    this.zoneService.getZone(zoneId).subscribe(
      (zone) => {
        this.zone = zone;
        this.isDataLoaded = true;
        this.isModified = false;
      },
      (err) => {
        if (err.status == 404) {
          this.isDataLoaded = true;
          this.showErrorMessage("Zone not found");
        }
      }
    );

    this.priceService.getPricesByZoneId(zoneId).subscribe(
      (prices) => {
        this.prices = prices;
        this.dataSource.data = prices;
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;

        this.isDataLoaded = true;
        this.isModified = false;
      },
      (err) => {
        if (err.status == 404) {
          this.isDataLoaded = true;
          this.prices = [];
          this.dataSource.data = [];
        }
      }
    );
  }

  public ngOnInit(): void {
    this.dataSource = new MatTableDataSource<Price>();
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.zone = new Zone();
    this.courierService.getCouriers().subscribe(
      (couriers) => {
        this.couriers = couriers;
      },
      (err) => {
        this.showErrorMessage("Cannot retrieve couriers");
      }
    );
    this.activatedRoute.paramMap
      .pipe(
        switchMap((params: ParamMap) => {
          const stateId = params.get("id");
          if (!this.globals.isNullOrEmpty(stateId)) {
            this.loadData(parseInt(stateId, 10));
          } else {
            this.showErrorMessage("Please specify the zone Id!");
          }

          return Promise.resolve();
        })
      )
      .subscribe();
  }

  public refresh(): void {
    this.isDataLoaded = false;
    this.loadData(this.zone.id);
  }

  isZoneValid() {
    return this.zone.name && this.zone.code;
  }

  public save(): void {
    if (!this.isZoneValid()) {
      this.showErrorMessage("Name or code is required");
      return;
    }

    this.zoneService.updateZone(this.zone).subscribe(
      (res) => {
        this.refresh();
      },
      (err) => {
        console.error(err);
        this.showErrorMessage(
          "Sorry, your request cannot be process at the moment!"
        );
      }
    );
  }

  public showErrorMessage(message): void {
    this.snackBar.open(message, "Error", {
      duration: 2000,
    });
  }

  public updateList(price: ProductPrice, propertys: string, value: any) {
    console.log(value);
  }

  viewPrice(id: number) {
    const priceDialogRef = this.priceDialog.open(EditPriceDialogComponent, {
      data: {
        addPrice: false,
        zoneId: this.zone.id,
        priceId: id,
      },
    });

    priceDialogRef.afterClosed().subscribe((result) => {
      console.log("Price Dialog: ", result);
      this.refresh();
    });
  }

  deletePrice(id: number) {
    this.priceService.deletePrice(id).subscribe((result) => {
      this.refresh();
    });
  }
}
